import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { AbstractApiService } from '../../shared/services';
import { AbstractApiResponse } from '../../shared/models';
import { LabLocation } from '../models';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class LabLocationsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  readLabLocation(iri: string): Observable<LabLocation> {
    return this.rolesService.userHasRoleFilter<LabLocation>(
      'ROLE_MWS_LAB_LOCATION_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readLabLocations(): Observable<AbstractApiResponse | any> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_LAB_LOCATION_LIST',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(`/lab_locations`)
    );
  }
}
